"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._Metadata = {
    type: "map",
    key: {
        shape: {
            type: "string"
        }
    },
    value: {
        shape: {
            type: "string"
        }
    }
};
//# sourceMappingURL=_Metadata.js.map